import './Notification.css';
import {useEffect, useState} from "react";
import {useNotification} from "../../context/NotificationContext/NotificationContext.jsx";

export default function Notification({type,message}) {
    const [render,setRender]=useState('on');
    const {displayNotification,setDisplayNotification}= useNotification();
    if(displayNotification===null) return;

    useEffect(() => {
        if(displayNotification !== null){
            const timer1 = setTimeout(() => {
                setRender('off'); // trigger animation
            }, 3000);

            const timer2 = setTimeout(() => {
                setDisplayNotification(null); // unmount after animation finishes
            }, 4000); // <- not 1000!

            return () => {
                clearTimeout(timer1);
                clearTimeout(timer2);
            };
        }
    }, [displayNotification]);




    return <div id='notification-container' className={`notification-${displayNotification.type} notification-${render}-render`}>
        <span id='notification-text'>{displayNotification.message}</span>
        <div id='notification-icon' class={`notification-icon-${displayNotification.type}`}>

        </div>
    </div>;
}
